import {HeroSection} from '@/shared/components/dashboard/landing-pages/form/HeroSection';
import {Menus} from '@/shared/components/dashboard/landing-pages/form/MenusSection';
import {Impression} from '@/shared/components/dashboard/landing-pages/form/ImpressionSection';
import {Introduction} from '@/shared/components/dashboard/landing-pages/form/IntroductionSection';
import {RoutePlan} from '@/shared/components/dashboard/landing-pages/form/RoutePlanSection';
import {Location} from '@/shared/components/dashboard/landing-pages/form/LocationSection';
import {Accommodation} from '@/shared/components/dashboard/landing-pages/form/AccommodationSection';
import {Activities} from '@/shared/components/dashboard/landing-pages/form/ActivitiesSection';
import {Videos} from '@/shared/components/dashboard/landing-pages/form/Videos';
import {Security} from '@/shared/components/dashboard/landing-pages/form/SecuritySection';

export const COLUMNS_HEADERS = [{id: 'label', key: 'label', label: 'Label'}];

export const RECORDS_PER_PAGE = 20;

export const LANDING_PAGE_ACCORDION_ITEMS = {
  heroSection: {
    value: 'heroSection',
    label: '1. Hero Section',
    Component: HeroSection,
  },
  menusSection: {
    value: 'menusSection',
    label: '2. Call To Action Button (Menus)',
    Component: Menus,
  },
  introductionSection: {
    value: 'introductionSection',
    label: '3. Introduction Section',
    Component: Introduction,
  },
  impressionSection: {
    value: 'impressionSection',
    label: '4. Impression Section',
    Component: Impression,
  },
  routePlanSection: {
    value: 'routePlanSection',
    label: '5. Route Plan Section',
    Component: RoutePlan,
  },
  locationSection: {
    value: 'locationSection',
    label: '6. Location Section',
    Component: Location,
  },
  accommodationSection: {
    value: 'accommodationSection',
    label: '7. Accommodation Section',
    Component: Accommodation,
  },
  activitiesSection: {
    value: 'activitiesSection',
    label: '8. Activities Section',
    Component: Activities,
  },
  videosSection: {
    value: 'videosSection',
    label: '9. Videos Section',
    Component: Videos,
  },
  securitySection: {
    value: 'securitySection',
    label: '10. Security Section',
    Component: Security,
  },
};
